import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-skills',
  standalone: false,
  templateUrl: './admin-skills.component.html',
  styleUrl: './admin-skills.component.css'
})
export class AdminSkillsComponent implements OnInit {
  skills: any = [];
  authToken = localStorage.getItem('auth');
  isLoading = false;
  selectedBusiness: any;
  currentSkill: any;
  edit_form: FormGroup;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  get edit_fi() { return this.edit_form.get('e_fi') };
  get edit_en() { return this.edit_form.get('e_en') };
  get edit_sv() { return this.edit_form.get('e_sv') };

  ngOnInit(): void {
    this.edit_form = this.fb.group({
      e_fi: ['', [
        Validators.required,
      ]],
      e_en: ['', [
        Validators.required,
      ]],
      e_sv: ['', [
        Validators.required,
      ]],
    });

    this.fetchSkills();
  }

  fetchSkills() {
    //Fetch skills that are not assigned
    this.http.get(environment.ADMIN_UNASSIGNED_SKILLS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.skills = res.message;

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }
  editSkill(skill) {
    this.currentSkill = skill;
    this.edit_fi.setValue(skill.name_fi);
    this.edit_en.setValue(skill.name_en);
    this.edit_sv.setValue(skill.name_sv);
  }

  saveEdit() {
    var req = {
      skillID: this.currentSkill._id,
      name_fi: this.edit_fi.value,
      name_en: this.edit_en.value,
      name_sv: this.edit_sv.value
    }

    this.http.put(environment.ADMIN_EDIT_SKILL, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.fetchSkills();
          document.getElementById('close_edit').click();
        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })

  }

  rejectSkill(data) {
    this.isLoading = true;
    this.http.put(environment.ADMIN_REJECT_SKILL, { skillID: data._id }, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.isLoading = false;
          this.fetchSkills();
          this.currentSkill = null;
        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {
        this.isLoading = false;
        console.log("Error while finding status :: ", err);
      })
  }
}
